<template>
  <div class="tools col-12">
    <p class="h6 title">
      Tools
    </p>
    <div
      v-for="(value, key, i) in titles"
      :key="i" class="section"
    >
      <div class="titles" @click="toggleSection(key)">
        <span
          class="section-title" :class="{ 'active-title': key === activeSection }"
        >{{ key }}</span>
        <Arrow :class="{ rotate: key === openedSection }" />
      </div>
      <div
        class="links" :class="{ open: key === openedSection }"
      >
        <nuxt-link
          v-for="(valueLinks, keyLinks, iLinks) in value" :key="iLinks"
          :to="keyLinks"
          class="nuxt-link"
        >
          {{ valueLinks.name }}
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>
import Arrow from '@itbpbg/lms-components/src/assets/svg/calculator-arrow.svg?vue-component';

export default {
  components: { Arrow },
  data() {
    return {
      titles: {
        calculators: {
          '/calculators/confidence-interval-calculator/': {
            name: 'Confidence Interval Calculator',
            lowerCaseName: 'confidence interval',
            component: 'confidenceInterval',
          },
          '/calculators/mean-median-mode-calculator/': {
            name: 'Mean, Median, Mode Calculator',
            lowerCaseName: 'mean, median, mode',
            component: 'meanMedianMode',
          },
          '/calculators/skewness-calculator/': {
            name: 'Skewness Calculator',
            lowerCaseName: 'skewness',
            component: 'skewness',
          },
          '/calculators/kurtosis-calculator/': {
            name: 'Kurtosis Calculator',
            lowerCaseName: 'kurtosis',
            component: 'kurtosis',
          },
          '/calculators/variance-calculator/': {
            name: 'Variance Calculator',
            lowerCaseName: 'variance',
            component: 'variance',
          },
          '/calculators/standard-deviation-calculator/': {
            name: 'Standard Deviation Calculator',
            lowerCaseName: 'standard deviation',
            component: 'standardDeviation',
          },
          '/calculators/coefficient-of-variation-calculator/': {
            name: 'Coefficient of Variation Calculator',
            lowerCaseName: 'coefficient of variation',
            component: 'coefficientOfVariation',
          },
          '/calculators/linear-regression-calculator/': {
            name: 'Linear Regression Calculator',
            lowerCaseName: 'linear regression',
            component: 'linearRegression',
          },
          '/calculators/p-value-calculator/': {
            name: 'P-Value Calculator',
            lowerCaseName: 'p value',
            component: 'pValue',
          },
          '/calculators/hypothesis-test-calculator/': {
            name: 'Hypothesis Test Calculator',
            lowerCaseName: 'hypothesis test',
            component: 'hypothesisTest',
          },
          '/calculators/difference-in-means-calculator/': {
            name: 'Difference in Means Calculator',
            lowerCaseName: 'difference in means',
            component: 'differenceInMeans',
          },
        },
        tables: {
          '/calculators/tables/std-table/': {
            name: 'Student’s T Distribution t-table',
          },
          '/calculators/tables/snd-table/': {
            name: 'Standard Normal Distribution z-table',
          },
          '/calculators/tables/fd-table/': {
            name: 'F-Distribution Critical Values Table',
          },
        },
      },
      activeSection: '',
      openedSection: '',
      currentUrl: '',
    };
  },
  watch: {
    currentUrl() {
      if (this.$store.state.layout === 'desktop') {
        this.openedSection = this.activeSection;
      }

      if (this.activeSection === 'calculators') {
        this.$store.commit('calculators/calculator', this.titles[this.activeSection][this.currentUrl].component);
        this.$store.commit('calculators/calculatorName', this.titles[this.activeSection][this.currentUrl].lowerCaseName);
      }
    },
  },
  created() {
    this.currentUrl = this.$route.path;
    this.activeSection = this.currentUrl.split('/')[2] !== 'tables' ? 'calculators' : 'tables';
  },
  methods: {
    toggleSection(key) {
      if (this.activeSection !== key) {
        this.activeSection = key;
      }
      if (this.openedSection === key) {
        this.openedSection = '';
      } else {
        this.openedSection = key;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tools {
  margin-right: 0;

  .section {
    .titles {
      display: flex;
      height: 52px;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;

      span {
        text-transform: capitalize;

        &:hover {
          font-weight: 600;
          color: var(--accent-shade-2);
        }

        &.active-title {
          font-weight: 600;
          color: var(--accent-shade-2);
        }
      }
    }

    .links {
      margin: var(--spacing-12) 0;
      display: none;

      .nuxt-link {
        display: block;
        color: var(--main-dark);
        transition: unset;
        margin-left: var(--spacing-16);

        &:hover,
        &.nuxt-link-active {
          font-weight: 600;
          color: var(--accent-shade-2);
        }

        &:not(:last-child) {
          margin-bottom: var(--spacing-24);
        }

        &:nth-last-child() {
          margin-bottom: var(--spacing-12);
        }
      }

      &.open {
        display: block;
      }
    }
  }

  svg {
    height: 6px;

    &.rotate {
      transform: rotateZ(-180deg);

      path {
        stroke-width: 2.2px;
      }
    }
  }

  ::v-deep .ab-banner.side {
    .banner-title {
      .first {
        font-size: 20px;
        font-weight: 500;
        line-height: 22px;

        .dash {
          width: 60px;
        }
      }

      .second {
        font-size: 24px;
        line-height: 20px;
        font-weight: 600;
      }

      .title {
        font-size: 42px;
        font-weight: 700;
        line-height: 38px;
        letter-spacing: -0.42px;
      }

      .third {
        font-size: 32px;
        font-weight: 600;
        line-height: 26px;
      }
    }
  }

  .sticky {
    position: sticky;
    top: 90px;
  }
}

.top-banner + .calculators .tools .sticky {
  top: 186px;
}

@include bp($bp-laptop) {
  .tools {
    ::v-deep .ab-banner.side {
      .banner-title {
        .first {
          font-size: 16px;
          line-height: 18px;

          .dash {
            width: 48px;
          }
        }

        .second {
          font-size: 20px;
          line-height: 16px;
        }

        .title {
          font-size: 34px;
          line-height: 30px;
        }

        .third {
          font-size: 24px;
          line-height: 27px;
        }
      }
    }
  }
}

@include bp($bp-mobile) {
  .tools {
    margin-bottom: var(--spacing-36);
    padding: 0 var(--spacing-24);

    .section {
      .titles {
        .section-title {
          font-size: 18px;
        }
      }
    }

    .h6 {
      font-size: 21px;
    }

    ::v-deep .ab-banner.side {
      display: none;
    }
  }
}
</style>
